/* eslint-disable max-lines */
import type { IStatus } from '@/types/status'
export { default as ERRORS } from './errors'
export { GOOGLE_SSO_SUCCESS, LOGIN, RESET_PASSWORD, SIGNUP, SYSTEM_USE_NOTICE } from './login'
export {
  CONTROL_STATUS,
  CONTROL_TABLE,
  CONTROL_DRAWER,
  CONTROL_FILTERS,
  CONTROL_BULK_ACTIONS,
  CONTROL_OWNER_SELECTOR,
  CONTROL_STATUS_SELECTOR,
  CONTROL_COLUMN_FILTER,
} from './controls'
export {
  DOCUMENT_STATUS,
  TEXT_DOCUMENT_VERSION_STATUS,
  DOCUMENT_CLASSIFICATION,
  TEXT_DOCUMENT_VERSIONS,
  TEXT_DOCUMENT_EDITOR,
  TEXT_DOCUMENT_MENTION,
  TEXT_DOCUMENT_ATTRIBUTES,
  DOCUMENT_TABLE,
  DOCUMENT_DETAIL,
  DOCUMENT_COMMENTS,
  DOCUMENT_FILTERS,
  DOCUMENT_COLUMN_FILTER,
  DOCUMENT_BULK_ACTIONS,
  DOCUMENT_OWNER_SELECTOR,
  DOCUMENT_STATUS_SELECTOR,
} from './documents'
export {
  EVIDENCE_STATUS,
  EVIDENCE_TABLE,
  EVIDENCE_DRAWER,
  EVIDENCE_DETAIL,
  EVIDENCE_FILTERS,
  EVIDENCE_COLUMN_FILTER,
  EVIDENCE_BULK_ACTIONS,
  EVIDENCE_OWNER_SELECTOR,
  EVIDENCE_STATUS_SELECTOR,
} from './evidences'
export { default as CLOUD_SECURITY } from './cloud-security'
export {
  HARDENING_CLUSTERS,
  HARDENING_POLICY_STATUS,
  HARDENING_ASSET_TYPES,
  HARDENING_ASSET_TABLE,
  HARDENING_ASSETS_DETAILS,
} from './hardening'
export {
  NON_CONFORMITIES_TABLE,
  NON_CONFORMITY_DRAWER,
  NON_CONFORMITY_CATEGORIES_LABELS,
  NON_CONFORMITY_STATUS_LABELS,
  NON_CONFORMITY_MESSAGES,
  NON_CONFORMITY_DIALOG,
  NC_STATUS,
  NC_CATEGORIES,
  NC_HEADER,
  NC_FILTERS,
  NC_TYPE_FILTER,
  NC_CREATION_DIALOG,
  NC_DELETE_DIALOG,
  NC_BULK_UPLOAD_DIALOG,
} from './nonConformities'
export {
  TASK_STATUS,
  TASK_TABLE,
  TASK_CREATION_DIALOG,
  TASK_DETAILS,
  TASK_DELETE_DIALOG,
  TASK_DRAWER,
  TASK_NOTES,
  TASK_HEADER,
  TASK_FILTERS,
  TASK_LIST_HEADER,
  TASK_ITEM,
  TASK_ATTRIBUTES,
  TASK_DESCRIPTION,
  BULK_UPLOAD_DIALOG,
  CONTROL_SELECTOR,
  DOCUMENT_SELECTOR,
  EVIDENCE_SELECTOR,
  TASK_BULK_ACTIONS,
  TASK_CSV_VALIDATION,
} from './tasks'
export { STANDARD_EDITOR } from './standard-editor'
export { SELECTION_BAR, TABLE_COMPONENT_TEXTS } from './tableComponent'
export { TENANT_CREATION_DIALOG, TENANTS } from './tenants'
export { SCANS } from './scans'
export { CYBERSECURITY_INDICATORS } from './cybersecurity-indicators'
export { TRUST_CENTER } from './trust-center'
export { USERS } from './users'
export { COCKPIT } from './cockpit'
export { CUSTOMER_SUCCESS } from './customer-success'
export { BACKOFFICE_ORGANIZATIONS } from './backoffice-organizations'
export {
  EMPLOYEE_BULK_ACTIONS,
  EMPLOYEE_TABLE,
  EMPLOYEE_CREATION_DIALOG,
  EMPLOYEE_DRAWER,
  SIGNED_POLICIES,
  TRAINING_STATUS_TEXTS,
  EDR_AGENT_STATUS_TEXTS,
  EMPLOYEE_BULK_UPLOAD_DIALOG,
  ONBOARDING_SECTION,
  OFFBOARDING_SECTION,
  DEPARTMENT_SELECTOR,
  CHECKLIST_EDIT,
} from './employees'
export { APPSEC } from './appsec'
export { PUBLIC_TRUST_CENTER } from './public-trust-center'
export { PUBLIC_TRUST_CENTER_LEGACY } from './public-trust-center-legacy'
export { EASM_DASHBOARD, EASM_PUBLIC_DOMAINS, EASM_CERTIFICATES, EASM_VULNERABILITIES, EASM_BREACHES } from './easm'
export { EDR_DASHBOARD } from './edr'
export { ASSETS } from './assets'
export { IT_INVENTORY } from './it-inventory'
export { REVIEW_ENTRIES } from './review-entries'
export const TABLE_HEADER = {
  NAME: 'Nombre',
  EMAIL: 'Correo',
  POLICIES_SIGNED: 'Políticas Firmadas',
  TRAINING_COMPLETED: 'Capacitación Completada',
  STATUS: 'Estado',
  STANDARD_ID: 'ID',
  STANDARD: 'Estándar',
  OWNER: 'Responsable',
  LAST_UPDATED: 'Última Edición',
  CLUSTER: 'Cluster',
  ASSET: 'Activo',
  INTERESTED_PARTY: 'Parte Interesada',
  ID: 'ID',
  TREATMENT: 'Tratamiento',
  CONTROLS: 'Controles',
  INHERENT_RISK: 'Riesgo Inherente',
  DISPLAY_ID: 'ID de Riesgo',
  RESIDUAL_RISK: 'Riesgo Residual',
  EFFECTIVENESS: 'Efectividad',
  CODE: 'Código',
  CREATED_AT: 'Fecha de Creación',
  CLOSED_DATE: 'Fecha de Cierre',
}

export const PLURALS = {
  CONTROL: 'Control',
  CONTROLS: 'Controles',
  STANDARD: 'Estándar',
  STANDARDS: 'Estándares',
  CLUSTER: 'Cluster',
  CLUSTERS: 'Clusters',
  ASSET: 'Activo',
  ASSETS: 'Activos',
  INTERESTED_PARTY: 'Parte Interesada',
  INTERESTED_PARTIES: 'Partes Interesadas',
  PROVIDER: 'Proveedor',
  PROVIDERS: 'Proveedores',
  ACCOUNT: 'Cuenta',
  ACCOUNTS: 'Cuentas',
  REGION: 'Región',
  REGIONS: 'Regiones',
  DEPARTMENT: 'Departamento',
  DEPARTMENTS: 'Departamentos',
  SUPPLIER: 'Proveedor',
  SUPPLIERS: 'Proveedores',
}

export const NO_CLOSED_DATE = 'Sin Fecha'
export const NO_CREATED_AT = 'Sin Fecha'

export const BULK_EDIT_MESSAGE = {
  OWNER_UPDATED: 'Responsables actualizados',
  STATUS_UPDATED: 'Estados actualizados',
}

export { POLICIES_LIST } from './policies'
export {
  RISK_TABLE,
  RISK_BULK_UPLOAD_DIALOG,
  RISK_CREATION_DIALOG,
  RISK_DETAILS,
  RISK_STATUS,
  RISK_TREATMENT_LABELS,
  RISK_TREATMENT,
  RISK_TREATMENT_DESCRIPTIONS,
  RISK_ASSESSMENT,
  RISK_ASSESSMENT_TABLE,
  RISK_ASSESSMENT_STATUS,
  RISK_LEVELS,
  RISK_CONTROLS_TABLE,
  RISK_DELETE_DIALOG,
  RISK_FILTERS,
  RISK_BULK_ACTIONS,
  RISK_DRAWER,
  RISK_HISTORY,
  RISK_LEVEL_SELECTOR,
  RISK_FORM,
  RISK_MESSAGES,
  RISK_ASSETS,
  NO_ASSET,
  ASSET_SELECTOR,
  AFFECTED_ASSETS_SELECTOR,
  RISK_INTERESTED_PARTIES,
  NO_INTERESTED_PARTY,
  INTERESTED_PARTY_SELECTOR,
  NO_CONTROL,
  RISK_DASHBOARD,
} from './risks'
export {
  RISK_THREAT_NAMES,
  RISK_VULNERABILITY_NAMES,
  RISK_THREATS_SELECTOR,
  RISK_VULNERABILITIES_SELECTOR,
  RISK_IMPACT_DIMENSIONS_SELECTOR,
} from './riskThreatsVulnerabilities'
export { RISK_CATALOGUE_SCENARIO_TEXTS, RISK_CATALOGUE } from './riskCatalogueScenarios'
export { RISK_TREATMENT_PLANS } from './riskTreatmentPlans'

export const SELECTOR_TEXTS = {
  STATUS: 'Estado',
  CONTROLS: 'Controles',
  DOCUMENTS: 'Documentos',
  EVIDENCES: 'Evidencias',
  OWNER: 'Responsable',
  TENANTS: 'Tenants',
}

export { INSIGHT_DETAIL, INSIGHT_CRITICALITY_LEVEL } from './insights'
export { AUTOMATIC_PENTESTING } from './automatic-pentesting'
export { EDR_SIEM, SIEM_DASHBOARD } from './siem'
export { PASSWORD_MANAGER } from './password-manager'
export { PHISHING } from './phishing'
export { TRAINING } from './training'
export { VULNERABILITIES } from './vulnerabilities'
export { CODE_SCANNER } from './codeScanner'
export { SIDEBAR, COMMON, PAYWALL } from './navigation'
export { ATTRIBUTES, EXTERNAL_LINKS, FILES, NO_NAME } from './details'
export { CLUSTERS_TEXT as CLUSTERS, NO_CLUSTER, CLUSTER_SELECTOR } from './clusters'
export { CRISIS_MANAGER } from './crisis-manager'
export { ALERTS } from './alerts'
export { APPROVED_SOFTWARE } from './approved-software'
export const STATUS_TEXTS = {
  approved: 'Aprobado',
  completed: 'Completado',
  inProgress: 'En Curso',
  notApplicable: 'No Aplicable',
  notStarted: 'No Iniciado',
  open: 'Abierto',
  muted: 'Silenciado',
  closed: 'Cerrado',
  inReview: 'En Revisión',
  planned: 'Planeado',
  delayed: 'Atrasado',
  error: 'Error',
} satisfies Record<IStatus, string>
export const SCAN_FREQUENCY = {
  QUARTERLY: 'Trimestral',
  MONTHLY: 'Mensual',
  TOOLTIP: {
    QUARTERLY_SINGLE: 'Este escaneo se realiza una vez por trimestre',
    QUARTERLY_MULTIPLE: 'Estos escaneos se realizan una vez por trimestre',
    MONTHLY_SINGLE: 'Este escaneo se realiza una vez al mes',
    MONTHLY_MULTIPLE: 'Estos escaneos se realizan una vez al mes',
  },
}
export const ALL = 'Todos'
export const CLEAR_FILTER = 'Limpiar'
export const SEARCH_PLACEHOLDER = 'Buscar Nombre/ID'
export const DATE_FILTER = {
  FROM: 'Desde',
  TO: 'Hasta',
}
export const FILTER_OPTIONS = {
  owner: 'Responsable',
  cluster: 'Cluster',
  status: 'Estado',
  standards: 'Estándares',
  createdAt: 'Fecha de Creación',
  deadline: 'Fecha Límite',
  inherentRisk: 'Riesgo Inherente',
  residualRisk: 'Riesgo Residual',
  effectiveness: 'Efectividad',
  treatment: 'Tratamiento',
}
export const NO_OWNER = 'Sin Responsable'
export const DATE = 'Fecha'
export const OWNER = 'Responsable'
export const RESOURCE_VIEW = {
  TABLE: 'Tabla',
  KANBAN: 'Kanban',
  FILTER_BY: 'Filtrar por',
  NEW: (resourceType: string) => {
    const resourceTypeMap = {
      task: 'Crear Tarea',
      risk: 'Añadir Riesgo',
      nonConformity: 'Añadir NC',
    }
    const customLabel = resourceTypeMap[resourceType as keyof typeof resourceTypeMap]
    if (customLabel) {
      return customLabel
    }
    return `Crear ${resourceType}`
  },
}
export const RELATED_TABLES = {
  DOCUMENTS: 'Documentos',
  CONTROLS: 'Controles',
  EVIDENCES: 'Evidencias',
}
export { SEVERITIES } from './severities'
export { ERROR_PAGE } from './errorPage'
export { MAINTENANCE_PAGE } from './maintenance'
export const UNDER_MAINTENANCE = 'En Mantenimiento Temporal'
export const POLICIES = 'Políticas'
export const DOCUMENTS = 'Documentos'
export const EVIDENCES = 'Evidencias'
export const DEFAULT_PLACEHOLDER = 'Haz clic para agregar descripción...'
export {
  SUPPLIERS_LIST,
  SUPPLIERS_DETAILS,
  SUPPLIER_CREATION_DIALOG,
  SUPPLIER_FORM,
  SUPPLIER_MESSAGES,
} from './suppliers'
export { HOME_PAGE, NEW_HOME } from './home-page'
export {
  CONNECTORS_LIST,
  CONNECTION_SUCCESS,
  CONNECTION_FAILED,
  MICROSOFT_INTEGRATION,
  GITHUB_INTEGRATION,
  GCP_INTEGRATION,
  AWS_INTEGRATION,
} from './connectors'
export { IDENTITIES_LIST } from './identities'
export { EMPLOYEE_CENTER } from './employee-center'
export { SUPPLIER_QUESTIONNAIRES } from './supplier-questionnaires'
export { CONTEXT_DOCUMENTS } from './context-documents'
export { DEPARTMENT_DELETE_DIALOG, DEPARTMENT_MESSAGES, DEPARTMENTS, EMPLOYEE_DASHBOARD_TABS } from './departments'
export { SERVICE_ACCOUNTS } from './serviceAccounts'
export { MDM_GROUPS, MDM_GROUPS_MESSAGES, MDM_GROUPS_DELETE_DIALOG, MDM_GROUPS_PLATFORMS } from './mdm-groups'
export {
  MDM_SOFTWARE,
  MDM_SOFTWARE_TABS,
  MDM_SOFTWARE_FILTERS,
  MDM_SOFTWARE_STATUS,
  MDM_SOFTWARE_PLATFORM,
  MDM_SOFTWARE_DRAWER,
  MDM_SOFTWARE_CARD,
  MDM_SOFTWARE_DIALOG,
  MDM_SOFTWARE_FORM,
  MDM_SOFTWARE_MESSAGES,
} from './mdm-software'
export {
  MDM_SCRIPTS,
  MDM_SCRIPTS_TABLE,
  MDM_SCRIPTS_SUMMARY,
  MDM_SCRIPTS_STATUS,
  MDM_SCRIPTS_PLATFORMS,
  MDM_SCRIPTS_RUN_STATUS_BAR,
  MDM_SCRIPTS_RUN_DIALOG,
  MDM_SCRIPTS_DRAWER,
  MDM_SCRIPTS_RUN_ITEM,
  MDM_SCRIPTS_FORM,
  MDM_SCRIPTS_MESSAGES,
  MDM_SCRIPTS_DELETE_DIALOG,
} from './mdm-scripts'
export { MDM_POLICIES, MDM_POLICIES_MESSAGES, MDM_PROFILES } from './mdm-policies'
export { MDM_POLICY_LISTS } from './mdm-policy-lists'
export { MDM_DASHBOARD } from './mdm-dashboard'
export { CHATBOT } from './chatbot'
export { ASSET_MANAGER } from './assetManager'
export { DRAWER_STACK } from './drawers'
